module.exports = __webpack_public_path__ + "static/cafe-36ccd6f6527e92c2bb6f240bb2df91ee.jpg";